/* =========================================================
   FG Product Gallery Swiper Init (SAFE + SCOPED)
   - Only touches MainProduct section galleries
   - Avoids double-init (mobile + desktop duplicates)
   - Avoids Swiper "navigation.enabled" crash by NEVER setting
     navigation/pagination to undefined (only add when present)
   ========================================================= */
(function () {
  if (typeof Swiper === 'undefined') return;

  var ROOT_SELECTOR = '[id^="MainProduct-"]';
  var WRAPPER_SELECTOR = '.product__media-list-wrapper';

  function isElementVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    if (el.offsetParent === null && style.position !== 'fixed') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function destroyIfExists(swiperHostEl) {
    try {
      if (swiperHostEl && swiperHostEl.swiper && !swiperHostEl.swiper.destroyed) {
        swiperHostEl.swiper.destroy(true, true);
      }
    } catch (e) {}
  }

  function initGalleryWithin(wrapper) {
    if (!wrapper) return;
    if (!isElementVisible(wrapper)) return;

    var thumbsEl = wrapper.querySelector('.js-media-sublist.swiper.no-js-hidden');
    var mainEl = wrapper.querySelector('.js-media-list.swiper.no-js-hidden');

    if (!thumbsEl) thumbsEl = wrapper.querySelector('.product__media-sublist-outer.no-js-hidden .js-media-sublist.swiper');
    if (!mainEl) mainEl = wrapper.querySelector('.js-media-list.swiper');

    if (!thumbsEl || !mainEl) return;

    var thumbsWrap = thumbsEl.querySelector('.swiper-wrapper');
    var mainWrap = mainEl.querySelector('.swiper-wrapper');
    if (!thumbsWrap || !mainWrap) return;

    // Prevent “double init” when Shopify rerenders
    destroyIfExists(thumbsEl);
    destroyIfExists(mainEl);

    var prevBtn = wrapper.querySelector('.product__button-prev');
    var nextBtn = wrapper.querySelector('.product__button-next');

    // Build thumbs config WITHOUT navigation unless we have buttons
    var thumbsConfig = {
      slidesPerView: 4,
      spaceBetween: 10,
      freeMode: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      // observers can create weird loops in some themes; keep off by default
      observer: false,
      observeParents: false,
      breakpoints: {
        750: { slidesPerView: 5 }
      }
    };

    if (prevBtn && nextBtn) {
      thumbsConfig.navigation = { prevEl: prevBtn, nextEl: nextBtn };
    }

    var thumbsSwiper;
    try {
      thumbsSwiper = new Swiper(thumbsEl, thumbsConfig);
    } catch (e) {
      // If thumbs fails, don’t attempt main with thumbs enabled
      return;
    }

    // Main config WITHOUT pagination unless present
    var isMobileWrapper = !!wrapper.closest('.product__media-wrapper--mobile');
    var paginationEl = isMobileWrapper ? wrapper.querySelector('.fg-mobile-gallery-pagination') : null;

    var mainConfig = {
      slidesPerView: 1,
      spaceBetween: 10,
      watchOverflow: true,
      observer: false,
      observeParents: false,
      loop: false,
      thumbs: { swiper: thumbsSwiper }
    };

    if (paginationEl) {
      mainConfig.pagination = { el: paginationEl, clickable: true };
    }

    var mainSwiper;
    try {
      mainSwiper = new Swiper(mainEl, mainConfig);
    } catch (e2) {
      try { thumbsSwiper.destroy(true, true); } catch (e3) {}
      return;
    }

    // Ensure layout recalculates once images are decoded
    window.setTimeout(function () {
      try { thumbsSwiper.update(); } catch (e) {}
      try { mainSwiper.update(); } catch (e2) {}
    }, 50);
  }

  function initAll(root) {
    var scope = root || document;

    scope.querySelectorAll(ROOT_SELECTOR).forEach(function (sectionEl) {
      var wrappers = Array.prototype.slice.call(sectionEl.querySelectorAll(WRAPPER_SELECTOR));
      if (!wrappers.length) return;

      var visible = wrappers.find(isElementVisible) || wrappers[0];
      initGalleryWithin(visible);

      // Destroy the duplicate wrapper instances (mobile/desktop) so they don’t fight
      wrappers.forEach(function (w) {
        if (w !== visible) {
          var t = w.querySelector('.js-media-sublist.swiper');
          var m = w.querySelector('.js-media-list.swiper');
          destroyIfExists(t);
          destroyIfExists(m);
        }
      });
    });
  }

  var rafToken = null;
  function scheduleInit(root) {
    if (rafToken) cancelAnimationFrame(rafToken);
    rafToken = requestAnimationFrame(function () {
      rafToken = null;
      initAll(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleInit(document); });
  } else {
    scheduleInit(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    scheduleInit(e.target);
  });

  document.addEventListener('variant:change', function () {
    scheduleInit(document);
  });

  document.addEventListener('product:media-change', function () {
    scheduleInit(document);
  });
})();